// Common precompiled regex patterns (avoids recompiling on every call)
const DIACRITICS_REGEX = /[\u0300-\u036f]/g;
const PUNCTUATION_REGEX = /[^\w\s]/g;
const DASH_REGEX = /-/g;
const WHITESPACE_REGEX = /\s+/g;

// Normalize author names for comparison or slugging
export const normalizeName = (name) =>
  name?.normalize('NFD')
    .replace(DIACRITICS_REGEX, '')
    .replace(PUNCTUATION_REGEX, '')
    .toLowerCase()
    .trim();

// Convert normalized name to slug
export const slugifyName = (name) =>
  normalizeName(name).replace(WHITESPACE_REGEX, '-');

// Convert slug back to normalized name
export const unslugifyName = (slug) =>
  slug.replace(DASH_REGEX, ' ').replace(WHITESPACE_REGEX, ' ').trim();
